const openingHoursSelector = document.querySelector('[data-opening-hours]');
const pageLoader = document.querySelector('[data-page-loader]');

export default function initOpeningHoursNav() {
    // Jump to location page when location is selected
    if (openingHoursSelector) {
        openingHoursSelector.addEventListener('change', (e) => {
            pageLoader.classList.remove('hidden');
            window.location.href = e.target.value;
        });
    }
}
